// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/power-patrol.scss
// module id = 105
// module chunks = 0